import type { TickerDwell, TickerKind, TickerLevel } from './api'

/**
 * Which kinds each detail level shows on the conveyor. The levels NEST - Management within High
 * within Detail - so Detail is everything (Andrew, 29 Sep 2026; they were disjoint slices and Detail
 * showed completed tasks only). The server's LEVEL_GROUPS is the same rule. rta_change is not in any
 * list because it is admitted at EVERY level: the server joins every watcher to the set's rta room
 * whatever level they chose, and the client admits it the same way.
 */
const MGMT_KINDS: readonly TickerKind[] = ['management_update', 'engineer_update']
const HIGH_KINDS: readonly TickerKind[] = ['object_complete', 'task_issue', ...MGMT_KINDS]
export const LEVEL_KINDS: Record<TickerLevel, readonly TickerKind[]> = {
    detail: ['task_complete', ...HIGH_KINDS],
    high: HIGH_KINDS,
    mgmt: MGMT_KINDS,
}

export function levelAdmits(level: TickerLevel, kind: TickerKind): boolean {
    return kind === 'rta_change' || LEVEL_KINDS[level].includes(kind)
}

/** The slide, as the prototype: 520 ms on cubic-bezier(.33,0,.2,1). */
export const SLIDE_MS = 520
export const SLIDE_EASE = 'cubic-bezier(.33,0,.2,1)'

/**
 * How long a card stays on the bar, by the user's "Time on screen" setting: the short kinds (task
 * and object completions) and the rest. Whole seconds, so the menu can state them exactly - they
 * were 2.6 s / 5.2 s scaled by x0.6 and x1.6, which the menu could only show as 1.6-3.1 s and the
 * like (Andrew, 25 Sep). A completion still passes faster than an issue or an update at every
 * setting. The countdown bar runs for the same time; the 520 ms slide does not change.
 */
export const DWELL_MS: Record<TickerDwell, { short: number; long: number }> = {
    quick: { short: 2000, long: 3000 },
    normal: { short: 3000, long: 5000 },
    slow: { short: 4000, long: 8000 },
}

export function dwellFor(kind: TickerKind, dwell: TickerDwell = 'normal'): number {
    const times = DWELL_MS[dwell] ?? DWELL_MS.normal
    return kind === 'task_complete' || kind === 'object_complete' ? times.short : times.long
}
